import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { setup as setupLocale } from './i18n';
import reportWebVitals from './reportWebVitals';
import { initializeSentry } from '@/service/sentry';

initializeSentry(Number(process.env.REACT_APP_SENTRY_SAMLPE_RATE));

async function render() {
  await setupLocale();

  ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root'),
  );
}

render();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
